import { useEffect, useRef, useState } from "react";

/**
 * useInView — triggers when element enters the viewport
 * @param {Object} options - IntersectionObserver options
 * @param {boolean} once - only trigger once (default: true)
 */
export function useInView(options = {}, once = true) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (once) observer.unobserve(element);
        } else if (!once) {
          setIsVisible(false);
        }
      },
      { threshold: 0.15, ...options }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [once, options]);

  return [ref, isVisible];
}
